module.exports = __webpack_public_path__ + "static/img/marmalade_pictgrid12_800x649.6d3b8a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marmalade_pictgrid12_800x649.jpg
// module id = NWxP
// module chunks = 0